<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel">
                        <h2>{{tituloDaEtapaAtual}}</h2>
                    </div>
                </div>
            </div>

            <div>
                <div>
                    <mat-divider fxFlex="1 0"></mat-divider>
                </div>
                <div *ngIf="usuarioLogado.username" class="text-danger" style="margin-top: 5px; margin-bottom: 5px;">
                    Atendente Logado: {{usuarioLogado.username}}
                </div>
                <form [formGroup]="formularioDeCadastroDePacienteConsultaCpf" (ngSubmit)="consultarPacientePorCpf()">
                    <div class="form-group">
                        <mat-divider fxFlex="1 0"></mat-divider>
                    </div>
                    <div class="panel-heading custom-sub-panel">
                        <div class="titulo-sub-painel">
                            <h3>Informações do Paciente</h3>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-lg-4 col-md-6 col-sm-10 col-10">
                            <label for="cpfPaciente">CPF</label>
                            <input type="text" class="form-control" id="cpfPaciente" name="cpfPaciente" nccCpfCnpjMask
                                formControlName="cpfPaciente" maxlength="14"
                                [readonly]="pacienteSelecionado || cpfValido" required trim="blur">
                        </div>
                        <div class="form-group col-lg-1 col-md-2 col-sm-2 col-2" style="align-self: flex-end;">
                            <button mat-mini-fab color="primary" type="submit" matTooltip="Consultar"
                                [disabled]="cpfValido">
                                <mat-icon>search</mat-icon>
                            </button>
                        </div>
                        <div class="form-group col-lg-7 col-md-4 col-md-4 col-sm-12 col-12"
                            style="align-self: flex-end; text-align: center;" *ngIf="temAgendamentos">
                            <button mat-raised-button mat-button color="visualizarAgendamentos"
                                class="mat-button-marcacao" style="width: 100%;"
                                (click)="navegarParaTelaDeAgendamentosDoPaciente()">
                                <mat-icon>calendar_month</mat-icon>
                                <span style="margin-left: 10px; white-space: break-spaces;">
                                    Visualize aqui seus agendamentos!
                                </span>
                            </button>
                        </div>
                    </div>
                </form>
                <form [formGroup]="formularioDeCadastroDePaciente" (ngSubmit)="onSubmit()"
                    (keydown.enter)="$event.preventDefault()">
                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label for="nome">Nome</label>
                            <input type="text" class="form-control" id="nome" formControlName="nome"
                                [readonly]="pacienteSelecionado || !cpfValido" upperCase>
                            <div *ngIf="formularioDeCadastroDePaciente.controls.nome.invalid && (formularioDeCadastroDePaciente.controls.nome.dirty || formularioDeCadastroDePaciente.controls.nome.touched)"
                                class="alert alert-danger">
                                <div *ngIf="formularioDeCadastroDePaciente.controls.nome.errors!.required">
                                    O campo Nome é obrigatório.
                                </div>
                                <div *ngIf="formularioDeCadastroDePaciente.controls.nome.errors!.minlength">
                                    O campo Nome precisa conter mais do que 5 caracteres.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-4">
                            <label for="dataNascimento">Data Nasc.</label>
                            <input type="date" class="form-control" id="dataNascimento" formControlName="dataNascimento"
                                [readonly]="pacienteSelecionado || !cpfValido">
                            <div *ngIf="formularioDeCadastroDePaciente.controls.dataNascimento.invalid && (formularioDeCadastroDePaciente.controls.dataNascimento.dirty || formularioDeCadastroDePaciente.controls.dataNascimento.touched)"
                                class="alert alert-danger">
                                <div *ngIf="formularioDeCadastroDePaciente.controls.dataNascimento.errors!.required">
                                    O campo Data de Nascimento é obrigatório.
                                </div>
                                <div
                                    *ngIf="formularioDeCadastroDePaciente.controls.dataNascimento.errors!.dataValidada">
                                    O campo Data de Nascimento está inválido.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-md-4">
                            <label for="foneResidencial">Fone Residencial</label>
                            <input type="text" class="form-control" id="foneResidencial"
                                formControlName="foneResidencial" [readonly]="!cpfValido" name="foneResidencial"
                                phoneMask [maskInputId]="'foneResidencial'"
                                [preValue]="formularioDeCadastroDePaciente.value.foneResidencial"
                                [phoneControl]="formularioDeCadastroDePaciente.controls['foneResidencial']"
                                maxlength="16">
                            <div *ngIf="formularioDeCadastroDePaciente.controls.foneResidencial.invalid && (formularioDeCadastroDePaciente.controls.foneResidencial.dirty || formularioDeCadastroDePaciente.controls.foneResidencial.touched)"
                                class="alert alert-danger">
                                <div *ngIf="formularioDeCadastroDePaciente.controls.foneResidencial.errors">
                                    O campo Fone Residencial está inválido.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-md-4">
                            <label for="foneCelular">Núm. Celular</label>
                            <input type="text" class="form-control" id="foneCelular" formControlName="foneCelular"
                                [readonly]="!cpfValido" name="foneCelular" phoneMask [maskInputId]="'foneCelular'"
                                [preValue]="formularioDeCadastroDePaciente.value.foneCelular"
                                [phoneControl]="formularioDeCadastroDePaciente.controls['foneCelular']" maxlength="16">
                            <div *ngIf="formularioDeCadastroDePaciente.controls.foneCelular.invalid && (formularioDeCadastroDePaciente.controls.foneCelular.dirty || formularioDeCadastroDePaciente.controls.foneCelular.touched)"
                                class="alert alert-danger">
                                <div *ngIf="formularioDeCadastroDePaciente.controls.foneCelular.errors">
                                    O campo Núm. Celular está inválido.
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-header">Dependentes</div>
                        <div class="card-body" style="padding-bottom: 0px;">
                            <table class="table table-striped table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">Nome</th>
                                        <th scope="col">Data Nasc.</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let dependente of dependentes; let i = index"
                                        (click)="onClickNaTabelaDeDependente(i)"
                                        [class.active]="i == numeroDaLinhaSelecionadaNaTabelaDeDependente">
                                        <td>{{dependente.nome}}</td>
                                        <td>{{formatDate(dependente.dataNascimento)}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-12" style="text-align: right;">
                                <button type="button" mat-button color="primary" matTooltip="Novo"
                                    style="margin-right: 20px;" [disabled]="!cpfValido || dependentes.length > 7"
                                    (click)="navegarParaTelaDeCadastroDeDependente()">Novo Dependente</button>
                                <!--
                    <button type="button" mat-button color="warn" matTooltip="Remover" style="margin-right: 20px;"
                        [disabled]="!cpfValido || numeroDaLinhaSelecionadaNaTabelaDeDependente == -1"
                        (click)="removerDependenteSelecionado()">Remover
                        Dependente</button>
                    -->
                            </div>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group botao-marcacao-esquerda col-12 col-sm-6 col-md-6 col-lg-6">
                            <button type="button" (click)="telaAnterior()" mat-raised-button color="warn"
                                matTooltip="Tela Incial" style="margin-bottom: 10px;" class="mat-button-marcacao">
                                <mat-icon>arrow_left</mat-icon>
                                Tela Inicial
                            </button>
                        </div>
                        <div class="form-group botao-marcacao-direita col-12 col-sm-6 col-md-6 col-lg-6">
                            <button mat-raised-button color="primary" type="submit" matTooltip="Continuar Marcação"
                                class="mat-button-marcacao"
                                [disabled]="!cpfValido || !formularioDeCadastroDePaciente.valid">Continuar
                                Marcação
                                <mat-icon>arrow_right</mat-icon>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>